/**
 * Hashes provided string and then returns a `Promise` which resolves
 * to a base64-encoded string.
 * @param string the string to be hashed
 */
export default async function sha256AndBase64(string) {
  const hash = await crypto.subtle.digest("SHA-256", (new TextEncoder()).encode(string));
  return btoa(String.fromCharCode(...new Uint8Array(hash)));
}
